import { render, staticRenderFns } from "./liveTeacherManager.vue?vue&type=template&id=65875a9b&scoped=true"
import script from "./liveTeacherManager.vue?vue&type=script&lang=js"
export * from "./liveTeacherManager.vue?vue&type=script&lang=js"
import style0 from "./liveTeacherManager.vue?vue&type=style&index=0&id=65875a9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65875a9b",
  null
  
)

export default component.exports